import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-primary-light border-t border-gray-100 mt-auto">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 section-padding-lg">
                <div className="md:flex md:items-center md:justify-between">
                    <div className="flex justify-center md:justify-start items-center gap-3">
                        <img src="/assets/images/logo-horizontal-dark.png" alt="Trustpoint Healthcare Solutions"
                            className="h-8 w-auto object-contain opacity-90 hover:opacity-100 transition-opacity" />
                    </div>

                    <div className="mt-8 md:mt-0 flex flex-col items-center space-y-4 md:flex-row md:space-y-0 md:space-x-6 md:order-2">
                        <a href="#dashboard" className="paragraph-sm hover:text-secondary">Platform</a>
                        <a href="#process" className="paragraph-sm hover:text-secondary">Process</a>
                        <a href="#success" className="paragraph-sm hover:text-secondary">Success Story</a>
                        <a href="#about" className="paragraph-sm hover:text-secondary">About Us</a>
                    </div>
                </div>

                <div
                    className="mt-8 border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
                    <p className="paragraph-sm">
                        &copy; {new Date().getFullYear()} Trustpoint Healthcare Solutions. All rights reserved.
                    </p>
                    <p className="paragraph-sm mt-4 md:mt-0">
                        Built by Clinicians, for Clinicians.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
